import Js from './images-technologies/javascript.png';
import node from './images-technologies/node.png';
import react from './images-technologies/react.png';
import mocha from './images-technologies/mocha.png';
import rtl from './images-technologies/rtl.png';
import sinon from './images-technologies/sinon.png';
import css from './images-technologies/css.png';
import html from './images-technologies/html.png';
import docker from './images-technologies/docker.png';
import sequelize from './images-technologies/sequelize.png';
import redux from './images-technologies/redux.png';
import mysql from './images-technologies/mysqll.png';
import ts from './images-technologies/ts.png';
import chai from './images-technologies/chai.png';
import git from './images-technologies/git.png';
import api from  './images-technologies/api.png';
import jest from './images-technologies/jest.png';
import express from './images-technologies/express.png';
import linux from './images-technologies/linux.png';
import hooks from './images-technologies/hooks.png';


const technologies = [
    { technology: 'JavaScript', image: Js},
    { technology: 'TypeScript', image: ts},
    { technology: 'HTML', image: html},
    { technology: 'CSS', image: css},
    { technology: 'React', image: react},
    { technology: 'Hooks', image: hooks},
    { technology: 'RTL', image: rtl},
    { technology: 'Jest', image: jest},
    { technology: 'Redux', image: redux},
    { technology: 'ContextAPi', image: react},
    { technology: 'Git', image: git},
    { technology: 'NodeJs', image: node},
    { technology: 'Express.js', image: express},
    { technology: 'Docker', image: docker},
    { technology: 'MySql', image: mysql},
    { technology: 'Sequelize', image: sequelize},
    { technology: 'Sinon', image: sinon},
    { technology: 'Mocha', image: mocha},
    { technology: 'Chai', image: chai},
    { technology: 'Api Rest', image: api},
    { technology: 'Linux', image: linux },
];

export default technologies;